/**
 * @param {Response} downloadResponse
 * @param {string} defaultFileName - Used as the download name unless overridden by Content-Disposition when useServerFileNameIfAvailable is true.
 * @param {boolean} [useServerFileNameIfAvailable=true] - When true, Content-Disposition filename wins when present. When false, defaultFileName is always used.
 */
export const fileDownload = async (downloadResponse, defaultFileName, useServerFileNameIfAvailable = true) => {
    const blob = await downloadResponse.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;

    const contentDisposition = downloadResponse.headers.get('Content-Disposition');
    let serverFilename = null;
    if (contentDisposition) {
        const filenameMatch = contentDisposition.split('filename=')[1];
        if (filenameMatch) {
            serverFilename = filenameMatch.replace(/"/g, '');
        }
    }

    link.download = defaultFileName;

    if (useServerFileNameIfAvailable && serverFilename) {
        link.download = serverFilename;
    }

    link.click();
    window.URL.revokeObjectURL(blobUrl);
};
